import React, { ComponentType, Dispatch, SetStateAction } from 'react';
import { State } from './State';
import { SlidingPaneAddNew } from '../../Page/SlidingPaneAddNewMinimal';
import { activityReservationMinimal } from '../../../schema/activityReservationMinimal';
import Box from "@mui/material/Box";

type Props = {
  formState: any;
  setFormState: any;
  slidingRef: React.RefObject<any>;
};

export const AddNewActivityReservationSchema: ComponentType<Props> = ({
  formState,
  setFormState,
  slidingRef,
}) => {

  return (
    <SlidingPaneAddNew
      ref={slidingRef}
      schema={activityReservationMinimal()}
      id={undefined}
      onSubmit={() => {}}
      propertiesFromTable={formState}
      onClose={() => {}}
      stepper={true}
    />
  );
};
